import { ActivatedRouteSnapshot, BaseRouteReuseStrategy } from '@angular/router';

/**
 * Route reuse strategy: defaults to Angular's BaseRouteReuseStrategy semantics
 * (reuse when future.routeConfig === curr.routeConfig). Routes opt OUT of reuse
 * by setting `data: { shouldDestroy: true }`, which forces destroy + remount on
 * navigation. Reserved for routes whose components rely on ngOnInit-only
 * lifecycle for initialization — currently matter create/edit and settings
 * general edit. Everything else should use the default (reuse), and list/edit
 * pages handle re-entry via SafariBasePageComponent.onPageReenter().
 */
export class SafariDefaultReuseStategy extends BaseRouteReuseStrategy {
  shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    if (future.data?.shouldDestroy === true) {
      return false;
    }
    return super.shouldReuseRoute(future, curr);
  }
}
